'use strict';

require('string.prototype.matchall/auto');

require('globalthis/auto');

require('promise.allsettled/auto');



//////////////////
// WEBPACK FOOTER
// ./node_modules/airbnb-js-shims/target/es2020.js
// module id = 1190
// module chunks = 31